export class DvirItem {
  readonly uuid: string;
  constructor() {
    this.uuid = crypto.randomUUID();
  }
}
